document.addEventListener('click', (event) => {

    const tab = event.target.closest('[data-product-tab]');

    if (!tab) {
        return;
    }

    const tile = tab.closest('.product-tile');

    if (!tile) {
        return;
    }

    const target = tab.dataset.productTab;

    const tabs = tile.querySelectorAll('[data-product-tab]');
    const panels = tile.querySelectorAll('[data-product-panel]');


    /*
     * Update tabs.
     */
    tabs.forEach((item) => {

        const isActive = item.dataset.productTab === target;

        item.classList.toggle('is-active', isActive);

        item.setAttribute(
            'aria-selected',
            isActive ? 'true' : 'false'
        );

    });


    /*
     * Update panels.
     */
    panels.forEach((panel) => {

        const isActive = panel.dataset.productPanel === target;

        panel.hidden = !isActive;

    });

});

const productViewerBreakpoint = window.matchMedia(
    '(min-width: 48rem)'
);

const initProductViewers = () => {

    if (!productViewerBreakpoint.matches) {
        return;
    }

    document
        .querySelectorAll(
            '.product-tile__viewer[data-product-viewer-src]'
        )
        .forEach((iframe) => {

            if (iframe.getAttribute('src')) {
                return;
            }

            const src = iframe.dataset.productViewerSrc;

            if (src) {
                iframe.setAttribute('src', src);
            }

        });

};

document.addEventListener(
    'DOMContentLoaded',
    initProductViewers
);

productViewerBreakpoint.addEventListener(
    'change',
    initProductViewers
);